import { render, staticRenderFns } from "./DirectPackageDetail.vue?vue&type=template&id=4e5b7cdf&scoped=true&"
import script from "./DirectPackageDetail.vue?vue&type=script&lang=js&"
export * from "./DirectPackageDetail.vue?vue&type=script&lang=js&"
import style0 from "./DirectPackageDetail.vue?vue&type=style&index=0&id=4e5b7cdf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b7cdf",
  null
  
)

export default component.exports